import {Component} from '@angular/core';

@Component({
  selector: 'app-display-large',
  templateUrl: './display-large.component.html',
  styleUrls: ['./display-large.component.scss']
})
export class DisplayLargeComponent {
}
